/*********************************************************
 * Import Third controls 
*********************************************************/
import React, { useEffect, useRef, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux';
import Grid from '@mui/material/Grid';
import moment from 'moment';
import { useIntl } from "react-intl";

import { dateTimeZoneToUTC, getUnitsNaturalOrder } from '../../../../../../../core/data/Helpers';

/*********************************************************
 * Import Controls
*********************************************************/
import { InputDate, Select, Button, Loading, Form } from 'Components';
import { DateRangePicker } from 'Components/uiControls/DatePicker'
import { NotificationManager } from 'Components/Notifications';
import { getPreferencesByKey } from 'Core/data/Helpers';
/*********************************************************
 * Actions
*********************************************************/
import { getVehicleTrails, updateShowVehicleTrailsTable, setVehicleTrailToPrint, updateShowVehicleTrails, searchUnitTypeEvents, vehicleTrailsSearchClipRequests } from 'Redux/actions';

import { TimeFrame, useTimeFrameComponent } from '@gpstrackit/gtc-react-controls'

import { setUnitVehicleTrail, setTripsModeActive } from '../../redux/slice';
import { useRealtimeUnits } from 'Core/hooks';

/*********************************************************
 * Styles
*********************************************************/
import './style.scss'
import { resetClipRequestDrawer, setClipRequestData } from '../../../../../../../components/Map/components/ClipRequestDrawerMap/redux/slice';

//ping - 131
/*********************************************************
 * Start the start date to the control
*********************************************************/
const initStartingDate = () => {
  let startingMonth = new Date()
  startingMonth.setHours(0, 0, 0);
  return startingMonth;
}

/*********************************************************
 * Start the end date to the control
*********************************************************/
const initEndDate = () => {
  let endMonth = new Date()
  endMonth.setHours(23, 59, 0);
  return endMonth;
}

/*********************************************************
 * Author:  Walter Paz Londoño
 * Date:    24 Abr 2021
 * Module:  Realtime Maps
 * 
 * Class associated to the Vehicle Trails elements
 ********************************************************/
const VehicleTrailsForm = (props) => {

  const { messages } = useIntl();
  const dispatch = useDispatch();

  const contactSelectorRef = useRef();

  const user = useSelector(state => state.securityRedux.user);

  const paramsVehicleTrails = useSelector(state => state.realtimeMapUtilitiesvehiclesTrailRedux.paramsVehicleTrails);
  const showVehicleTrails = useSelector(state => state.realtimeMapUtilitiesvehiclesTrailRedux.showVehicleTrails);
  const loadVehicleTrails = useSelector(state => state.realtimeMapUtilitiesvehiclesTrailRedux.loadVehicleTrails);
  const unitTypeEvents = useSelector(state => state.realtimeMapUtilitiesvehiclesTrailRedux.unitTypeEvents);
  const searchUnits = useRealtimeUnits({ trackFields: ['id', 'label', 'Label', 'show', 'useEcuSpeed', 'unitType', 'typeId'] });
  const loadingSearchUnits = useSelector(state => state.catalogsRedux.loadingUnits);
  const loadingUnitTypeEvents = useSelector(state => state.realtimeMapUtilitiesvehiclesTrailRedux.loadingUnitTypeEvents);
  const unitToPrint = useSelector(state => state.realtimeMapUtilitiesvehiclesTrailRedux.unitToPrint);
  const preferencesUser = useSelector(state => state.preferencesRedux.preferencesUser);
  const dateformat = useSelector(state => state.securityRedux.user.dateformat);
  const timeZone = useSelector(state => state.securityRedux.user.timeZone);
  const keyPreferences = "mapSettings";


  const [event, setEvent] = useState({ value: '0', text: messages['event_all'] })
  const [unit, setUnit] = useState()
  const [loadInfo, setLoadInfo] = useState(false)
  const [currentUnits, setCurrentUnits] = useState([])
  const [filters, setFilters] = useState([{ value: '0', text: messages['event_all'] }]);
  const [preferences, setPreferences] = useState({});
  const [preventAutoOpen, setPreventAutoOpen] = useState(
    !!(paramsVehicleTrails?.timeFrameOption?.id === 'custom')
  );

  const timeFrameOptions = [
    { id: "custom", label: messages['date_custom'] },
    { id: "today", label: messages['date_today'] },
    { id: "yesterday", label: messages['date_yesterday'] },
    { id: "week", label: messages['date_this_week'] },
    { id: "lastWeek", label: messages['date_last_week'] },
    { id: "thisMonth", label: messages['date_this_month'] },
    { id: "lastMonth", label: messages['date_last_month'] },
    //{ id: "quarter", label: messages['date_this_quarter'] },
    //{ id: "lastQuarter", label: messages['date_last_quarter'] },
  ]

  const timeFrame = useTimeFrameComponent(timeFrameOptions)

  const removeDuplicates = (originalArray, prop) => {
    var newArray = [];
    var lookupObject = {};

    for (var i in originalArray) {
      lookupObject[originalArray[i][prop]] = originalArray[i];
    }

    for (i in lookupObject) {
      newArray.push(lookupObject[i]);
    }
    return newArray;
  }
  /*********************************************************
  * Load the new start informtation to the form
  *********************************************************/
  useEffect(() => {
    if (paramsVehicleTrails && paramsVehicleTrails.event && !unit) {
      const { endDate: _endDate, event: _event, startDate: _startDate, unitId, timeFrameOption } = paramsVehicleTrails
      //Set unit
      const unitSelected = currentUnits.find((item) => item.id == unitId)
      const eventSelected = filters.find((item) => item.value == _event)

      setUnit(unitSelected)
      if (timeFrameOption) {
        timeFrame.onChangeSelect(timeFrameOption, _startDate, _endDate)
      }
      setEvent(eventSelected)
    }
  }, []);

  // After the render where option becomes "custom" (with preventAutoOpen=true),
  // DateRangePickerModal has already initialized its internal open state to false.
  // Now it's safe to restore preventAutoOpen so manual selection opens the calendar normally.
  useEffect(() => {
    if (preventAutoOpen && timeFrame.option?.id === 'custom') {
      setPreventAutoOpen(false);
    }
  }, [timeFrame.option]);

  useEffect(() => {
    if (preferencesUser) {
      let newPreferences = getPreferencesByKey(preferencesUser, keyPreferences);
      setPreferences(newPreferences);
    }
  }, [preferencesUser]);

  /*********************************************************
  * show load message to vehicle info return data
  *********************************************************/
  useEffect(() => {
    if (loadInfo && !loadVehicleTrails && !showVehicleTrails) {
      //No data
      NotificationManager.success(
        messages['realtimemaps_vehicletrails_nodata'],
        messages['maputilities_vehicletrails'],
        3000,
        null,
        null,
        'success',
        null
      );
    }
    setLoadInfo(loadVehicleTrails)
  }, [loadVehicleTrails])


  useEffect(() => {
    if (searchUnits && searchUnits?.length > 0) {
      let unitList = []
      searchUnits.map((unit) => {
        if (unit.id !== -1) unitList.push(unit)
      })
      setCurrentUnits(unitList);
    }
  }, [searchUnits])

  /*********************************************************
  * Add supported filters
  *********************************************************/
  useEffect(() => {
    if (unitTypeEvents && unitTypeEvents?.length > 0) {
      let currentFilters = [{ value: '0', text: messages['event_all'] }];
      unitTypeEvents?.map((event) => {
        if (event.eventId === 3) currentFilters.push({ value: 'Drive', text: messages['event_drive'] })
        if (event.eventId === 131) currentFilters.push({ value: 'Ping', text: messages['event_ping'] })
        if (event.eventId === 2 || event.eventId === 5)
          currentFilters.push(
            { value: 'TravelStartStop', text: messages['event_travelstartstop'] },
            { value: 'TravelStop', text: messages['event_travelstop'] },
            { value: 'TravelStart', text: messages['event_travelstart'] },
          )
        if (event.eventId === 1 || event.eventId === 6)
          currentFilters.push(
            { value: 'IgnitionOnOff', text: messages['event_ignition_off_on'] },
            { value: 'IgnitionOff', text: messages['event_ignition_off'] },
            { value: 'IgnitionOn', text: messages['event_ignition_on'] },
          );
      })
      let current = removeDuplicates(currentFilters, "value");
      setFilters(current);
    }
  }, [unitTypeEvents])

  useEffect(() => {
    const targetId = unitToPrint?.id ?? paramsVehicleTrails?.unitId;
    if (targetId == null || targetId === '' || currentUnits.length === 0) {
      return;
    }
    if (unit && String(unit.id) === String(targetId)) {
      return;
    }
    const unitSelected = currentUnits.find((item) => String(item.id) === String(targetId));
    if (unitSelected) {
      setUnit(unitSelected);
    }
  }, [unitToPrint, currentUnits, paramsVehicleTrails?.unitId])

  /*********************************************************
  * Get units from redux
  *********************************************************/
  const onGetVehicleTrails = () => {
    if (!unit) {
      return
    }
    // Clears the residual isATrip flag from a previous trips query.
    // Without this, paramsVehicleTrails.isATrip remains true and when paginating
    // in trails the reducer forwards it, activating isVehicleTrailsTrip=true
    // and showing the trips bar instead of the trails bar.
    dispatch(setTripsModeActive(false));
    dispatch(setUnitVehicleTrail(unit));
    const { isKph } = user
    const paramToGetTrails = {
      unitId: unit.id,
      event: event.value,
      startDate: moment.utc(timeFrame?.startDate).format(),
      endDate: moment.utc(timeFrame?.endDate?.seconds(59)).format(),
      limit: preferences?.trailRowsPerPage || 100,
      offset: 0,
      useEcuSpeed: unit?.useEcuSpeed,
      unitType: unit?.unitType,
      kph: isKph,
      isATrip: false,  // Clears the residual isATrip flag from previous trips query
      timeFrameOption: timeFrame.option
    };
    dispatch(resetClipRequestDrawer());
    dispatch(setClipRequestData());
    dispatch(getVehicleTrails(paramToGetTrails, unit?.label || unit?.Label));
    //Load clip requests for vehicle trails
    dispatch(vehicleTrailsSearchClipRequests({
      limit: preferences?.clipRequestsRowsPerPage || 50,
      dateRange: {
        start: moment.utc(timeFrame?.startDate).format(),
        end: moment.utc(timeFrame?.endDate?.seconds(59)).format(),
      },
      resetSearch: true,
      offset: 0,
      entities: [{ name: 'All', id: -1 }],
      hasStarred: false,
      hasNotes: false,
      isDeleted: false,
      status: 'all',
      openSearch: ''
    }));
  }

  /*********************************************************
  * Link button to show grid
  *********************************************************/
  const onShowGrid = () => {
    dispatch(updateShowVehicleTrailsTable(true));
  }

  return (
    <div>
      <Form
        ref={contactSelectorRef}
        onValidSubmit={() => {
          //save changes
          props?.onClearSearchList && props.onClearSearchList()
          onGetVehicleTrails();
        }}
      >
        <Grid container spacing={1}>
          <Grid item sm={12} className="cnt-date-range-driver">
            <Select
              id="vehicles"
              label={messages['realtimemaps_vehicletrails_unit']}
              value={unit}
              onChange={(event) => {
                setUnit(event);
                setEvent({ value: '0', text: messages['event_all'] });
                event?.typeId && dispatch(searchUnitTypeEvents(event.typeId));
                if (setVehicleTrailToPrint && event) {
                  dispatch(setVehicleTrailToPrint(event));
                  //dispatch(updateShowVehicleTrails(false));
                }
                setFilters([{ value: '0', text: messages['event_all'] }]);
              }}
              options={getUnitsNaturalOrder(currentUnits)}
              textField="label"
              valueField="id"
              placeholder={messages['vehicleView_select']}
              required
              requiredMessage={messages['realtimemaps_vehicletrails_vehicletrail_validateunit']}
              disabled={loadingSearchUnits}
            />
          </Grid>
          <Grid item sm={12} >
            <div className='form-item'>
              <TimeFrame
                isRequired
                filterSwitch={false}
                {...timeFrame}
                label={messages['reportsMainRT_selectTimeFrameRange']}
                placeholder={messages['reportsMainRT_timeFrameLabel']}
                requiredMessage={messages["required_field"]}
                customRangeDate={30}
                maxDate={moment().endOf('day').toDate()}
                dateFormat={dateformat || 'Y/m/d'}
                openDateRangePickerModalAutomatically={!preventAutoOpen}
              />
            </div>
          </Grid>
          <Grid item sm={12}>
            <Select
              label={messages['realtimemaps_vehicletrails_filter']}
              value={event || filters[0]}
              onChange={(event) => setEvent(event)}
              id="filterevent"
              className="width-select-drivers"
              options={filters || []}
              textField={'text'}
              valueField={`value`}
              required
              disabled={loadingUnitTypeEvents}
            />
          </Grid>
          {
            !loadVehicleTrails
            &&
            <Grid item sm={12} style={{ paddingTop: 20 }} >
              <Button
                id={'btn-save-vehicle-group'}
                type="button"
                onClick={() => {
                  contactSelectorRef.current.submit();
                }}
                className="btn-blue vehicleTrailsButton"
              >
                {messages['realtimemaps_vehicletrails_gettrail']}
              </Button>
            </Grid>
          }
          {
            loadVehicleTrails
            &&
            <Grid container spacing={0} direction="column" alignItems="center" justifyContent="center" >
              <Grid item xs={3} style={{ paddingTop: 20 }} >
                <Loading />
              </Grid>
            </Grid>
          }
          {
            showVehicleTrails
            &&
            <Grid item sm={12} >
              <p className={'vechicleVehicleTrailTable'} onClick={onShowGrid}>
                {messages['realtimemaps_vehicletrails_vehicletrail_table']}
              </p>
            </Grid>
          }
        </Grid>
      </Form>
    </div>
  )

}



export default VehicleTrailsForm;